import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Routes, Route, Navigate } from 'react-router-dom';

import Travelform from './travelform';
import Travelreport from './travelreport';
import Travelcalendar from './travelcalendar';
import CumulativeReport from './cumulativereport';
import Vistinggolfer from './visitgolfer';
import Availablereport from './availablereport';
import AppConfig from 'Constants/AppConfig';

const Travelr = () => (
  <div className="content-wrapper">
    <Helmet>
      <title>Travel | {AppConfig.appTitle}</title>
      <meta name="description" content="TSGA Master" />
    </Helmet>

    <Routes>
      {/* Default redirect */}
      <Route index element={<Navigate to="travelform" replace />} />

      {/* Pages */}
      <Route path="travelform" element={<Travelform />} />
      <Route path="travelreport" element={<Travelreport />} />
      <Route path="travelcalendar" element={<Travelcalendar />} />
      <Route path="cumulativereport" element={<CumulativeReport />} />
      <Route path="visitgolfers" element={<Vistinggolfer />} />
      <Route path="studentavailable" element={<Availablereport />} />
    </Routes>
  </div>
);

export default Travelr;
